"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        boxSizing: 'border-box',
        flexShrink: 0,
        color: theme.indigo3,
        lineHeight: 'inherit',
        '&[data-is-warning=true]': {
            color: theme.warningRed
        },
        '&[data-is-muted=true]': {
            color: theme.grey4,
            '&[data-is-warning=true]:hover': {
                color: theme.warningRed
            }
        },
        '&[data-is-disabled="true"]': {
            color: theme.grey4,
            '& img': {
                opacity: 0.3
            }
        }
    },
    prefix: {
        marginRight: 7,
        flexShrink: 0
    },
    suffix: {
        marginLeft: 7,
        flexShrink: 0
    },
    text: {
        color: `currentColor`,
        fontSize: 14,
        fontWeight: 400,
        whiteSpace: `nowrap`,
        outline: `none`,
        textDecoration: `none`,
        position: 'relative',
        '&:focus': {
            textDecoration: `underline`
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            height: constants_1.MIN_TARGET_SIZE,
            top: '50%',
            left: 0,
            right: 0,
            transform: 'translateY(-50%)'
        },
        ':not([data-is-disabled="true"]) > &:hover': {
            cursor: 'pointer',
            textDecoration: `underline`
        }
    }
});
//# sourceMappingURL=pushtext.href.style.js.map